import { UserRound, Clock, ShieldCheck, Lock } from 'lucide-react';
import MiCuenta from '../seguridad/MiCuenta';
import CierreDeSesion from '../seguridad/CierreDeSesion';
import SegundoFactorDelPersonal from '../seguridad/SegundoFactorDelPersonal';
import SolicitudesDatosPersonales from '../seguridad/SolicitudesDatosPersonales';

/* =====================================================================
   Las pantallas del carril `seguridad` · CUENTA Parte A
   =====================================================================
   «Mi cuenta» se monta desde aquí, sin tocar `ui/modulos.jsx` (caliente).
   Va en el mismo grupo que «Tus sesiones abiertas» y «Cambiar
   contraseña», que es donde una persona busca lo suyo. La entrada por el
   nombre de la cabecera (C3) la engancha el integrador en `AppShell`.
   ===================================================================== */
export default {
  orden: 5,
  grupos: [
    {
      grupo: 'Tu cuenta',
      items: [
        {
          id: 'mi-cuenta',
          etiqueta: 'Mi cuenta',
          icono: UserRound,
          min: 'CONSULTA',
          Comp: MiCuenta,
        },
      ],
    },
    {
      // Ajuste de EMPRESA, no de la persona: el cierre por inactividad de
      // esta empresa (R-SEG3). Va en «Administración», que es donde el
      // admin busca lo de su empresa. `fundirGrupos` lo une al grupo que
      // ya trae `ui/modulos.jsx`.
      grupo: 'Administración',
      items: [
        {
          id: 'cierre-de-sesion',
          etiqueta: 'Cierre de sesión',
          icono: Clock,
          min: 'ADMIN',
          Comp: CierreDeSesion,
        },
        {
          // ESTABILIDAD D6: si el personal (no solo dueño y admin) debe
          // usar segundo factor. Ajuste de la empresa, rol ADMIN.
          id: 'segundo-factor-personal',
          etiqueta: 'Segundo factor del personal',
          icono: ShieldCheck,
          min: 'ADMIN',
          Comp: SegundoFactorDelPersonal,
        },
        {
          // TODO-SIRVE F2: la bandeja de las solicitudes ARCO. Quien tiene
          // el permiso de atenderlas (ADMIN y arriba, migración 133).
          id: 'solicitudes-datos-personales',
          etiqueta: 'Solicitudes de datos personales',
          icono: Lock,
          permiso: 'datos.arco',
          min: 'ADMIN',
          Comp: SolicitudesDatosPersonales,
        },
      ],
    },
  ],
};
